<template>
    <div class="bg-transparent mt-1 p-0 unselectable"
         id="content-main">
        <b-navbar class=" text-white float-right bg-transparent" fixed="top"
                  style="width: 10% !important; margin-top: 15px">
            <!--            <i class="fas fa-circle-notch fa-spin bg-transparent"-->
            <!--               @click="startScreening"-->
            <!--               v-if="ceoWorking>0"/>-->
            <span
                    class="bg-transparent fade-out"
                    style="margin-top: -11px; margin-left: -7px; "
                    @click="startScreening"
                    v-if="ceoWorking">{{progress}}%</span>
            <i class="fas fa-check bg-transparent fade-out"
               @click="startScreening"
               v-if="!addingNewWordsIsInProgress && numberOfSpecifics <= 0"/>
            <span class="bg-transparent fade-out"
                  style="margin-top: -11px;"
                  @click="startScreening"
                  v-if="(DEVELOPMENT_MODE || (!addingNewWordsIsInProgress && !cleanupIsInProgress)) && 99 >= numberOfSpecifics && numberOfSpecifics > 0">{{numberOfSpecifics}}
                    </span>
            <i class="fas fa-infinity bg-transparent fade-out"
               @click="startScreening"
               v-if="!addingNewWordsIsInProgress && numberOfSpecifics > 99"/>
        </b-navbar>
      <div class="p-3"></div>
      <div class="p-1"></div>
      <div id="connectionFailed"
           class="bg-primary"
           v-if="apiConnectionFailed">
          <b-card
                  @click="startScreening"
                  class="m-0 pl-4 pr-4 pt-2 pb-2"
          >
              <b-btn
                      class="btn btn-danger btn-block"
              >{{$t('Something went wrong - Try again later')}}
              </b-btn>
          </b-card>
      </div>
      <transition-group name="progress-bar-complete" tag="p" class="mt-0 mb-0">
        <b-col
        v-for="bar in progressBar"
        :key="bar"
        class="progress-bar-item mt-0">
          <b-card
          class="mt-0 pl-2 pr-2 mb-0 border-light"
          >
            <div class="progress mt-0">
              <div class="progress-bar progress-bar-striped progress-bar-animated bg-success"
              role="progressbar"
              :style="'width: ' + progress + '%'" :aria-valuenow="progress" aria-valuemin="0"
              aria-valuemax="100"></div>
            </div>
          </b-card>
        </b-col>
      </transition-group>

      <transition-group name="all-done-complete" tag="p">
        <b-col v-for="done in allDone"
                    :key="done"
                    class="progress-bar-item mt-0">
          <div class="p-2 mr-2 ml-2" v-if="allDone">
            <b-alert class="m-1" show dismissible variant="info">
              {{$t('no gender issues in your word document found')}}
            </b-alert>
          </div>
        </b-col>
      </transition-group>
        <transition-group name="list-complete" tag="p">
            <b-col
                    v-for="specificTreeEntry in cleanedSpecifics(specificTreeForView)"
                    v-bind:key="specificTreeEntry.genderSpecific||''"
                    class="list-complete-item bg-transparent"
            >
                <b-card
                        border-variant="secondary"
                        class="mt-2 ml-3 mr-3 gender_card"
                        :aria-expanded="isVisible[specificTreeEntry.genderSpecific] ? 'true' : 'false'"
                        id="card"
                        @click="initialHighlightWord(specificTreeEntry.genderSpecific ||'', 1)">
                    <b-card-header class="p-2 border "
                                   id="header"
                                   v-b-toggle="'accordion-' + specificTreeEntry.genderSpecific + specificTreeEntry.entryNumber">
                      <ul class="list-group list-group-horizontal p-0">
                        <li class="col-10 list-group-item p-0">
                          <b-btn
                                  @click="highlightWord(specificTreeEntry.genderSpecific ||'', 1)"
                                  class="btn btn-secondary pb-2"
                                  @click.stop>
                                  <span
                                          class="spellchecker-underline">
                                  {{ specificTreeEntry.genderSpecific }}
                                      </span>
                          </b-btn>
                  </li>
                        <li class="list-group-item  p-0 col-1">
                      <ul class="list-group"
                      v-if="highlightBuffer.specific === specificTreeEntry.genderSpecific && isVisible[specificTreeEntry.genderSpecific]"
                      >
                      <li :class="[highlightBuffer.numberOfOccurrence<2 ? 'text-muted': '', 'p-0 pb-1 list-group-item fa fa-angle-up custom-button bg-transparent text-info text-center']"
                         @click="highlightWord(specificTreeEntry.genderSpecific,-1)"
                                @click.stop></li>
                      <li :class="[highlightBuffer.numberOfOccurrence<2 ? 'text-muted': '', 'p-0 pb-1 list-group-item fa fa-angle-down custom-button bg-transparent  text-info text-center']"
                         @click="highlightWord(specificTreeEntry.genderSpecific,1)"
                                @click.stop></li>
                      </ul>

                        </li>
                        <li class="list-group-item  p-0 col-1">
                     <ul class="list-group"
                      v-if="highlightBuffer.specific === specificTreeEntry.genderSpecific && isVisible[specificTreeEntry.genderSpecific]">
                      <li
                          class="p-0 list-group-item small text-info bg-transparent text-center">
                        {{ (highlightBuffer.index >-1) ? highlightBuffer.index + 1:'-' }}</li>
                      <li style=" margin-top: -20px;"
                          class="p-0 list-group-item text-info bg-transparent text-center">
                        _</li>
                      <li style=" margin-top: -5px;"
                          class="p-0 list-group-item small text-info bg-transparent text-center">
                        {{ highlightBuffer.numberOfOccurrence }}</li>
                      </ul>
                        </li>
                    </ul>
                    </b-card-header>
                    <b-collapse v-model="isVisible[specificTreeEntry.genderSpecific]" :id="'accordion-' + specificTreeEntry.genderSpecific + specificTreeEntry.entryNumber"
                                class="p-0">
                        <b-card-body
                                class="pb-2 pt-2 pl-1 pr-1">
                            <div class="pt-0 m-0" v-if="postReplaceSuccess">
                              <b-alert class="m-1" show dismissible variant="success">
                                {{postReplaceSuccess}}
                              </b-alert>
                            </div>
                          <div v-if="postReplaceInfo">
                              <b-alert  class="m-1" show dismissible variant="warning">
                                {{postReplaceInfo}}
                              </b-alert>
                            </div>
                          <div class="p-0 m-0" v-if="postReplaceNext && highlightBuffer.numberOfOccurrence>0">
                              <b-alert  class="m-1" show dismissible variant="info">
                                {{postReplaceNext}} '{{highlightBuffer.specific}}' {{ $t('by using the') }} <i class="fas fa-angle-down"></i> {{$t('button above')}}
                              </b-alert>
                            </div>
                            <b-list-group id="alternative-list" v-if="highlightBuffer.index>-1">
                                <b-list-group-item :key="specificTreeEntry.id+alternativeObject.alternative"

                                                   class="p-1"
                                                   id="alternative"
                                                   v-for="alternativeObject in cleanedAlternatives(specificTreeEntry.alternatives)">
                                    <b-button
                                            @click="replaceWord(specificTreeEntry, alternativeObject)"
                                            class="btn-success btn-block btn text-left button"
                                    >
                                      {{ personalizeShortformPlaceholder(alternativeObject.alternative) }}
                                      <i class="fas fa-check-circle text-white">
                                        </i>
                                    </b-button>
                                </b-list-group-item>
                            </b-list-group>
                            <b-list-group id="no-alternative-list">
                                <b-list-group-item class="p-1"
                                                   id="no-alternative"
                                                   v-if="cleanedAlternatives(specificTreeEntry.alternatives).length===0"
                                >
                                    <b-button
                                            class="btn-info disabled btn text-left"
                                    >
                                        {{$t('no gender neutral term found in gender app. get creative!')}}
                                        <i class="fas fa-lightbulb text-white"></i>
                                    </b-button>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card-body>
                        <b-card-footer
                                class="p-2  border">
                            <b-button
                                    v-if="highlightBuffer.index > -1"
                                    @click="ignore(specificTreeEntry)"
                                    class="btn btn-danger"
                            >
                              '{{ truncate(highlightBuffer.specific,8) }}' {{$t('ignore')}}
                                <i class="fas fa-ban text-white"
                                ></i>
                            </b-button>
                        </b-card-footer>
                    </b-collapse>
                </b-card>
            </b-col>
        </transition-group>
        <b-card-header v-if="DEVELOPMENT_MODE">highlightBuffer</b-card-header>
      <JsonData :json-string='highlightBuffer' v-if="DEVELOPMENT_MODE"></JsonData>
      <b-card-header v-if="DEVELOPMENT_MODE">specificTree</b-card-header>
      <JsonData :json-string='specificTree' v-if="DEVELOPMENT_MODE"></JsonData>
      <b-card-header v-if="DEVELOPMENT_MODE">paragraphTree</b-card-header>
      <JsonData :json-string='paragraphTree' v-if="DEVELOPMENT_MODE"></JsonData>
      <b-card-header v-if="DEVELOPMENT_MODE">global variables</b-card-header>
      <JsonData
      :json-string='{"genderAppRunning":genderAppRunning,"numberOfParagraphs":numberOfParagraphs,"numberOfSpecifics": numberOfSpecifics, "ceoWorking":ceoWorking, "cooWaiting":cooWaiting, "cooWorking":cooWorking, "hrWorking":hrWorking, "middleManagementWorking":middleManagementWorking, "addingNewWordsIsInProgress":addingNewWordsIsInProgress, "visible":isVisible,"shortformPlaceholderMenu":shortformPlaceholderMenu, "shortformPlaceholder":shortformPlaceholder, "textCache":textCache}'
      v-if="DEVELOPMENT_MODE"></JsonData>
      <b-btn class="btn btn-block" @click="middleManagement" v-if="DEVELOPMENT_MODE">middleManagement</b-btn>
      <b-btn class="btn btn-block" @click="hr" v-if="DEVELOPMENT_MODE">hr</b-btn>
    </div>
</template>

<script>
import { LektoratService } from '@/services/lektorat.service'
import JsonData from './JsonData'
import { StatisticsService } from '@/services/statistics.service'
import { DEVELOPMENT_MODE } from '../env'
import { ProfileService } from '@/services/profile.service'

var Vue = require('vue')
export default {
  name: 'list',
  components: { JsonData },
  data () {
    return {
      DEVELOPMENT_MODE: false,
      logoPath: '/img/logo.png',
      numberOfParagraphs: 0,
      token: '',
      shortformPlaceholder: '',
      postReplaceSuccess: '',
      postReplaceInfo: '',
      postReplaceNext: '',
      isVisible: {},
      apiConnectionFailed: false,
      genderAppRunning: false,
      paragraphTree: [],
      specificTree: [],
      specificTreeForView: [],
      middleManagementWaiting: 0,
      blacklist: [],
      highlightBuffer: { specific: '', index: 0, numberOfOccurrence: 0 },
      textCache: '',
      paragraphsCache: '',
      treeLock: 0,
      cooWaiting: 0,
      selected: null,
      options: [{
        value: 'd', text: 'Click "analyze body"', disabled: true
      }],
      hrWorking: 0,
      ceoWorking: 0,
      cooWorking: 0,
      middleManagementWorking: 0,
      backOfficeWorking: 0,
      marketingWorking: 0
    }
  },
  computed: {
    progressBar: function () {
      return (this.ceoWorking > 0) ? ['progressbar'] : []
    },
    allDone: function () {
      return (!this.specificTreeForView.length && this.genderAppRunning && !this.ceoWorking && !this.apiConnectionFailed) ? ['allDone'] : []
    },
    progress: function () {
      const percent = (1 - this.ceoWorking / this.numberOfParagraphs) * 100
      const cleanPercent = Math.min(100, percent)
      return (`${cleanPercent.toFixed(0)}`)
    },
    addingNewWordsIsInProgress: function () {
      return this.hrWorking + this.cooWorking > 0
    },
    cleanupIsInProgress: function () {
      return this.middleManagementWaiting + this.middleManagementWorking > 0
    },
    numberOfSpecifics: function () {
      return this.specificTree.length
    }
  },
  created () {
  },
  mounted () {
    this.DEVELOPMENT_MODE = DEVELOPMENT_MODE === 'true'
    this.getShortformPlaceholder()
    this.startScreening()
    StatisticsService.logLogin()
  },
  props: ['starForm', 'pairForm', 'singularForm', 'shortformPlaceholderMenu'],
  methods: {
    personalizeShortformPlaceholder (entry) {
      return entry.replace('*', this.placeholderForView(this.shortformPlaceholder))
    },
    async getShortformPlaceholder () {
      if (!this.getUsername()) return
      await ProfileService.getProfileDictionaryEntryStatistics(this.getUsername())
        .then((response) => {
          this.shortformPlaceholder = response.data.shortform_placeholder
        }).catch((error) => {
          console.log(error)
        })
    },
    placeholderForView (shortformPlaceholderKey) {
      const relevantPlaceholderKey = this.shortformPlaceholderMenu ? this.shortformPlaceholderMenu : shortformPlaceholderKey
      let viewable = '*'
      if (relevantPlaceholderKey === 'star') {
        viewable = '*'
      } else if (relevantPlaceholderKey === 'colon') {
        viewable = ':'
      } else if (relevantPlaceholderKey === 'lowdash') {
        viewable = '_'
      } else if (relevantPlaceholderKey === 'slash') {
        viewable = '/-'
      }
      return viewable
    },
    cleanedAlternatives: function (alternatives) {
      const instance = this
      if (!alternatives) return
      const filteredAlternatives = alternatives.filter(element => !(!instance.starForm && element.type === 'star') && !(!instance.pairForm && element.type === 'pair') && !(!instance.singularForm && element.numerus === 'Sg'))
      return this.removeDuplicatesByProp(filteredAlternatives, 'alternative')
    },
    truncate (str, n) {
      return (str.length > n) ? str.substr(0, n - 1) + '...' : str
    },
    cleanedSpecifics: function (specifics) {
      const instance = this
      if (!specifics) return
      const filteredSpecifics = specifics.filter(element => instance.singularForm || (element.alternatives[0].numerus || '') === 'Pl')
      return filteredSpecifics.filter(element => element)
    },
    softUpdateSpecificTreeForView: async function () {
      await this.getTransitionLock()
      // call the expensive updateTextCache after new values are entered to make sure the ordering is correct
      const uniqueSpecifics = this.removeDuplicatesByProp(this.specificTree, 'genderSpecific')
      const uniqueSpecificsAfterBlacklist = uniqueSpecifics.filter(specific => !this.blacklist.includes(specific.genderSpecific || ''))
      this.specificTreeForView = uniqueSpecificsAfterBlacklist.sort(this.byOccurence)
      await this.releaseTransitionLock()
    },
    alphabetic (a, b) {
      if ((a.genderSpecific || '') > (b.genderSpecific || '')) {
        return -1
      }
      if ((a.genderSpecific || '') < (b.genderSpecific || '')) {
        return 1
      }
      return 0
    },
    byOccurence (a, b) {
      // call updateTextCache after new values are entered to make sure the ordering is correct
      const textCacheCache = this.textCache
      // The replace is needed for strange bug where leading umlauts lead to "der Übungsleiter".search("Übungsleiter") working
      // but "der Übungsleiter".search('\\b' + ("Übungsleiter" || '') + '\\b') returns -1.

      const indexOfA = textCacheCache.search('\\b' + (a.genderSpecific.replace(/^[ÖÜÄöüä]/, '') || '') + '\\b')
      const indexOfB = textCacheCache.search('\\b' + (b.genderSpecific.replace(/^[ÖÜÄöüä]/, '') || '') + '\\b')
      if (indexOfA < indexOfB) {
        return -1
      }
      return 1
    },

    updateTextCache: async function () {
      let textCache = ''
      // eslint-disable-next-line no-undef
      await Word.run(async function (context) {
        // console.time()
        const documentBody = await context.document.body
        await documentBody.load('text')
        await context.sync()
        textCache = await documentBody.text
        // this takes 38 ms on a 20 page document.
        // console.timeEnd()
        return Promise.resolve('ACK')
      })
        .catch(error => wordErrorHandler(error))
      this.textCache = textCache
      this.paragraphsCache = textCache.split('\r')
      // console.log(this.paragraphsCache)
      return Promise.resolve('ACK')
    },
    isLoggedIn () {
      const token = Vue.default.cookie.get('token')
      if (!token) {
        const localStorageToken = localStorage.getItem('genderAppToken')
        return !!localStorageToken
      }
      return !!token
    },
    showStats () {
      console.log(this.DEVELOPMENT_MODE)
      return this.DEVELOPMENT_MODE
    },
    startScreening: async function () {
      // eslint-disable-next-line no-undef
      // await Office.context.document.removeHandlerAsync('documentSelectionChanged')
      // await Office.context.document.removeHandlerAsync(Office.EventType.DocumentSelectionChanged)
      this.genderAppRunning = false
      this.paragraphTree = []
      this.specificTree = []
      this.specificTreeForView = []
      this.blacklist = []
      this.isVisible = []
      this.hrWorking = 0
      this.transitionLock = 0
      this.cooWaiting = 0
      this.numberOfParagraphs = 0
      this.ceoWorking = 0
      this.highlightBuffer = { specific: '', index: -1, numberOfOccurrence: 0 }
      this.middleManagementWaiting = 0
      this.cooWorking = 0
      this.middleManagementWorking = 0
      this.treeLock = 0
      // this.textCache = ''
      // this.paragraphsCache = ''
      this.backOfficeWorking = 0
      this.marketingWorking = 0
      await this.updateTextCache()
      await this.hr()
      await this.coo()
      this.genderAppRunning = true
      await this.middleManagement()
      await this.goingToWork()
      return Promise.resolve('ACK')
    },
    waitForSilence: async function (noOfSecsWeWait = 0.5) {
      let disturbed = true
      while (disturbed) {
        disturbed = false
        for (var i = 0; i < noOfSecsWeWait * 2; i++) {
          if (this.addingNewWordsIsInProgress) {
            disturbed = true
          }
          await wait(500)
        }
      }
      return Promise.resolve('got it')
    },
    getTreeLock: async function () {
      while (this.treeLock > 0) {
        await wait(50)
      }
      this.treeLock = 1
      return Promise.resolve('got it')
    },
    releaseTreeLock: async function () {
      this.treeLock = 0
      return Promise.resolve('set it free')
    },
    getTransitionLock: async function () {
      await wait(100)
      while (this.transitionLock > 0) {
        await wait(100)
      }
      this.transitionLock = 1
      return Promise.resolve('got it')
    },
    releaseTransitionLock: async function () {
      this.transitionLock = 0
      return Promise.resolve('set it free')
    },
    hr: async function () {
      if (this.hrWorking > 1) return Promise.resolve('Too many cooks...')
      this.hrWorking++
      // Check for large changes, that are handled by the ceo
      await this.marketing()
      // Check for obsolete entries in specificTree
      this.hrWorking--
      return Promise.resolve('ack')
    },
    marketing: async function () {
      let parsItemsLength = 0
      // eslint-disable-next-line no-undef
      await Word.run(async (context) => {
        const pars = await context.document.body.paragraphs
        if (!pars) return Promise.resolve('Not ready yet')
        await pars.load('items')
        await pars.load('length')
        await context.sync()
        parsItemsLength = pars.items.length || 0
        return Promise.resolve('ACK')
      })
        .catch(error => wordErrorHandler(error))
      // We need to send the ceo if there is a big shift in clients
      if (Math.abs(parsItemsLength - this.numberOfParagraphs) > 1) {
        // lots of new clients, CEO has to check everyone
        // i.e. probably c/p of multiple paragraphs, recheck whole doc.
        await this.updateTextCache()
        await this.ceo(parsItemsLength)
      } else {
        // will be handled by coo
        this.numberOfParagraphs = parsItemsLength
      }
      return Promise.resolve('ACK')
    },
    goingToWork () {
      // Business as usual.
      // We can only register one Handler, so COO calls hr() in the end.
      // eslint-disable-next-line no-undef
      Office.context.document.addHandlerAsync(Office.EventType.DocumentSelectionChanged, this.coo)
    },
    ceo: async function (numberOfParagraphsToAnalyse) {
      // Analyze the the next n paragraphs.
      // if a paragraph is not in the paragraphTree
      // he waits for intern to do the job before going to the next paragraph.
      // no early exit, should be handled by marketing/hr
      if (this.ceoWorking > 0) return Promise.resolve('Too many cooks')
      const numberOfPar = numberOfParagraphsToAnalyse
      this.numberOfParagraphs = numberOfPar
      this.ceoWorking = numberOfPar
      const chunkSize = 9
      const intraChunkIndices = Array.from(Array(chunkSize).keys())
      // With this chunkSize we get numberOfPar / chunkSize chunks to work with.
      const chunkIndices = Array.from(Array(Math.floor(numberOfPar / chunkSize) + 1).keys())
      for (const chunkIndex of chunkIndices) {
        await this.getTreeLock()
        try {
          this.ceoWorking ? await Promise.allSettled(intraChunkIndices.map(intraChunkIndex => this.ceoHelper(chunkIndex * chunkSize + intraChunkIndex))) : console.log('reset')
        } catch (err) {
          console.error(err)
        }
        // if (chunkIndex % cooldownChunk === cooldownChunk - 1) this.waitForSilence()
        this.releaseTreeLock()
        this.ceoWorking = this.ceoWorking - chunkSize
        if (this.ceoWorking < 0) {
          // Whatever happened here, we are stopping it.
          this.ceoWorking = 0
          break
        }
      }
      this.ceoWorking = 0
      return Promise.resolve('done')
    },
    ceoHelper: async function (paragraphIndex) {
      let parText = ''
      // eslint-disable-next-line no-undef
      if (paragraphIndex > this.paragraphsCache.length || 0) return Promise.resolve('CEO was overshooting')

      if (this.DEVELOPMENT_MODE) await console.log('current paragraph', paragraphIndex)
      const cleanIndex = paragraphIndex.mod((this.paragraphsCache.length || 1))
      const par = this.paragraphsCache[cleanIndex] || ''
      parText = par || ''
      if (this.DEVELOPMENT_MODE) console.log('to analyze: ' + parText)
      if (parText.trim()) await this.intern(parText)
      return Promise.resolve('ACK')
    },
    coo: async function () {
      // Analyze the paragraph of the cursor
      // Sends intern to update, if paragraph not in paragraphTree
      if (this.cooWaiting > 0) return Promise.resolve('Too many cooks')
      this.cooWaiting++
      await this.waitForSilence(0.5)
      this.cooWaiting--
      this.cooWorking++
      await this.getTreeLock()
      let parText = ''
      let previousParText = ''
      let previousPreviousParText = ''
      const instance = this
      // eslint-disable-next-line no-undef
      await Word.run(async (context) => {
        var pars = await context.document.getSelection().paragraphs
        pars.load('items')
        await context.sync()
        var par = pars.items[0] || undefined
        par.load('text')
        await context.sync()
        parText = par.text || ''
        try {
          const previousPar = await par.getPreviousOrNullObject()
          const previousPreviousPar = await previousPar.getPreviousOrNullObject()
          previousPreviousPar.load('text')
          previousPar.load('text')
          await context.sync()
          previousParText = await previousPar.text || ''
          previousPreviousParText = await previousPreviousPar.text || ''
        } catch (e) {
          // probably Office 2016 user
          // getPreviousOrNullObject is Word API 1.3 (Office 2019)
        }
        return Promise.resolve('ACK')
      })
        .catch(error => wordErrorHandler(error))
      if (parText.trim()) await instance.intern(parText)
      if (previousParText.trim()) await instance.intern(previousParText)
      if (previousPreviousParText.trim()) await instance.intern(previousPreviousParText)
      this.releaseTreeLock()
      // Check if multiple paragraphs changed.
      await this.hr()
      this.cooWorking--
      await this.middleManagement()
      return Promise.resolve('done')
    },
    middleManagement: async function () {
      // Todo: Implement in 'extract text & work on that'
      try {
        if (this.middleManagementWaiting > 0) {
          return Promise.resolve('at least one is waiting, let\'s go home')
        }
        // We are the only waiter
        this.middleManagementWaiting++
        await this.waitForSilence(0.5)
        // We made it without disturbance
        this.middleManagementWaiting--
        this.middleManagementWorking++
        // await this.getTreeLock()
        const instance = this
        // eslint-disable-next-line no-undef
        // We have to create a copy of the original tree because otherwise it gets messy after deletions.
        // Hint: Deletions in removeFromArray are by value and not by index
        const workingCopySpecificTree = instance.specificTree
        for (let i = 0, len = workingCopySpecificTree.length; i < len; i++) {
          const specific = workingCopySpecificTree[i] || "{'genderSpecific':'$$$','hash':'420'}"
          const indexofFirstMatch = this.textCache.search('\\b' + (specific.genderSpecific.replace(/^[ÖÜÄöüä]/, '') || '') + '\\b')
          if (indexofFirstMatch < 0) {
            // The word is no longer in the document, let's remove it, no matter the other
            // The word is no longer in the document, let's remove it, no matter the other
            // considerations, it needs to go. If the doc was changed or if it's the last document, we don't care.
            instance.paragraphTree = removeFromArray(instance.paragraphTree, specific.hash)
            instance.specificTree = removeFromArray(instance.specificTree, specific)
            // for a smooth transition animation
            await this.softUpdateSpecificTreeForView()
            continue
          }
          var paragraphOfSpecificIsStillAround = false
          const paragraphsWhereSpecificIsFound = this.paragraphsCache.filter(item => item.search('\\b' + (specific.genderSpecific.replace(/^[ÖÜÄöüä]/, '') || '') + '\\b') > -1)
          for (let j = 0, len = paragraphsWhereSpecificIsFound.length; j < len; j++) {
            const _par = paragraphsWhereSpecificIsFound[j] || "{'text':'Error. Sad face'}"
            const _parClean = cleanUpString(_par)
            if (_parClean.hashCode() === specific.hash) {
              paragraphOfSpecificIsStillAround = true
            }
          }
          // Ok, here we do the real cleanup. We get rid of old entries with paragraph hashes that are obsolete
          // this is a delicate thing, because the user is maybe right at it with changing the document.
          // this changes the hash of the paragraph but the genderSpecific term should still show up.
          // So we have two safety measures in place:
          // 1. if the document was changed, be break
          // 2. if it's the last entry in the specificTree (but the word is still in the document s.a.) we break
          // In any case, a later middlemanagement will do the cleaning up.
          const addOccurences = (accumulator, currentValue) => accumulator + ((currentValue.genderSpecific || '') === (specific.genderSpecific || '') ? 1 : 0)
          const lastElementStanding = instance.specificTree.reduce(addOccurences, 0) <= 1
          if (!paragraphOfSpecificIsStillAround && (specific.longCount > 1 || !lastElementStanding)) {
            // if (!paragraphOfSpecificIsStillAround && !lastElementStanding) {
            instance.paragraphTree = removeFromArray(instance.paragraphTree, specific.hash)
            instance.specificTree = removeFromArray(instance.specificTree, specific)
            this.softUpdateSpecificTreeForView()
          }
          if (!paragraphOfSpecificIsStillAround && lastElementStanding) specific.longCount += 1
          if (paragraphOfSpecificIsStillAround) specific.longCount = 0
        }
        await this.hardUpdateSpecificTreeForView()
        this.middleManagementWorking--
      } catch (e) {
        console.log(e)
      }
    },

    hardUpdateSpecificTreeForView: async function () {
      // invalidates entries in the paragraphTree if the paragraph is no longer available.
      // Without the treelock we can sort stuff even while the ceo is working.
      // await this.getTreeLock()
      await this.updateTextCache()
      this.softUpdateSpecificTreeForView()
      // this.releaseTreeLock()
      return Promise.resolve('ACK')
    },
    intern: async function (paragraphText) {
      // sends one paragraph to gender app and updates contentControls if paragraphHash is still valid after that
      const instance = this
      const paragraphTextClean = cleanUpString(paragraphText)
      const hash = await paragraphTextClean.hashCode()
      if (instance.paragraphTree.includes(hash)) {
        if (this.DEVELOPMENT_MODE) console.log('already analyzed')
        return Promise.resolve('already analyzed')
      }
      // Synchronize the document state by executing the queued commands,
      // and return a promise to indicate task completion.
      let queue = paragraphTextClean
      while (queue) {
        let response = null
        response = await LektoratService.fixRunningText(queue.substring(0, 512)).catch(e => {
          instance.apiConnectionFailed = true
          return 'CONNECTION_FAILED'
        })
        if (response === 'CONNECTION_FAILED') return Promise.resolve('Connetion failed')
        instance.apiConnectionFailed = false
        const lektorat = JSON.parse(response.result)
        if (lektorat.wordReplacer.entries.length === 0) {
          queue = queue.substring(512)
          continue
        }
        for (let i = 0, len = lektorat.wordReplacer.entries.length; i < len; i++) {
          lektorat.wordReplacer.entries[i].hash = hash
          lektorat.wordReplacer.entries[i].entryNumber = i
          lektorat.wordReplacer.entries[i].longCount = 0
        }
        const duplicateSpecifics = [...instance.specificTree, ...lektorat.wordReplacer.entries]
        // We don't want to trigger the textCache if we don't introduce a new word.
        // That means we don't reorder after reordering. tough luck.
        // Reasoning: Otherwise we update the textCache after every keystroke within a paragraph with a specific word.
        const oldSpecifics = [...new Set(instance.specificTree.map(item => item.genderSpecific || ''))].sort()
        const oldSpecificsJson = JSON.stringify(oldSpecifics)
        // No direct duplicates
        const duplicateSpecificsAfterBlacklist = duplicateSpecifics.filter(specific => !this.blacklist.includes(specific.genderSpecific || ''))
        instance.specificTree = await this.removeDuplicates(duplicateSpecificsAfterBlacklist)
        instance.paragraphTree.push(hash)
        const newSpecifics = [...new Set(instance.specificTree.map(item => item.genderSpecific || ''))].sort()
        const newSpecificsJson = JSON.stringify(newSpecifics)
        if (newSpecifics && (oldSpecificsJson !== newSpecificsJson)) {
        // new arrivals, we want to refresh the specificTreeForView
          const deltaSpecifics = newSpecifics.filter(x => !oldSpecifics.includes(x))
          console.log(JSON.stringify(deltaSpecifics))
          deltaSpecifics.forEach((s) => StatisticsService.logSearch(s))
          await this.hardUpdateSpecificTreeForView()
        }
        StatisticsService.logAnalysedParagraph().catch(e => {
        // instance.apiConnectionFailed = true
        })
        queue = queue.substring(512)
      }
      return Promise.resolve('New entries added')
    },
    initialHighlightWord: async function (specific, findNext) {
      if (this.highlightBuffer.specific !== specific) {
        await this.highlightWord(specific, findNext)
      }
    },
    highlightWord: async function (specific, findNext) {
      this.postReplaceSuccess = ''
      this.postReplaceInfo = ''
      this.postReplaceNext = ''
      // eslint-disable-next-line no-return-assign
      Object.keys(this.isVisible).forEach(v => this.isVisible[v] = false)
      this.isVisible[specific] = true
      const instance = this
      // eslint-disable-next-line no-undef
      await Word.run(async function (context) {
        var specificRanges = await context.document.body.search(specific, { matchWholeWord: true })
        var selctionRange = await context.document.getSelection()
        selctionRange.load('text')
        specificRanges.load('items')
        specificRanges.load('length')
        let fontLoaded = true
        try {
          context.load(specificRanges, 'font')
        } catch (e) {
          fontLoaded = false
        }
        await context.sync()
        const numberOfOccurrence = specificRanges.items.length
        instance.highlightBuffer.numberOfOccurrence = numberOfOccurrence
        const bufferedSpecific = instance.highlightBuffer.specific
        const bufferedIndex = instance.highlightBuffer.index
        // const bufferedSpecific = ''
        // const bufferedIndex = 0
        let nextHighlightIndex = 0
        if (selctionRange.text.trim !== specific.trim || bufferedIndex >= numberOfOccurrence) {
          nextHighlightIndex = 0
        } else if (specific === bufferedSpecific) {
          nextHighlightIndex = (bufferedIndex + findNext).mod(numberOfOccurrence)
        }
        instance.highlightBuffer.index = nextHighlightIndex
        instance.highlightBuffer.specific = specific
        // var nextHighlightIndex = 0
        var _range = await specificRanges.items[nextHighlightIndex]

        // strange workaround. But otherwise in Word 2016 the selection doesn't work.
        if (fontLoaded) {
          // eslint-disable-next-line no-self-assign
          _range.font.superscript = _range.font.superscript
        }
        _range.select()
        return Promise.resolve('highlighted')
      })
        .catch(error => wordErrorHandler(error))
      return Promise.resolve('done')
    },
    ignore: async function (specificTreeEntry) {
      this.paragraphTree = await removeFromArray(this.paragraphTree, this.hash)
      this.specificTree = await removeFromArray(this.specificTree, specificTreeEntry, 'genderSpecific')
      this.blacklist.push(specificTreeEntry.genderSpecific)
      this.softUpdateSpecificTreeForView()
      // No need in the current implementation, because the next entry isn't opend automatically
      // const index = await this.specificTreeForView.indexOf(specificTreeEntry)
      // await this.highlightNext(index)
      return Promise.resolve('ignored')
    },
    replaceWord: async function (specificTreeEntry, alternativeObject) {
      const personalizedShortformReplacement = this.personalizeShortformPlaceholder(alternativeObject.alternative)
      const instance = this
      // eslint-disable-next-line no-undef
      await Word.run(async function (context) {
        var _range = await context.document.getSelection()
        await _range.load('text')
        await context.sync()
        if ((specificTreeEntry.genderSpecific.toLowerCase() || '') !== _range.text.trim().toLowerCase()) {
          await instance.highlightWord(specificTreeEntry.genderSpecific, 0)
        }
        return Promise.resolve('ACK')
      })
        .catch(error => wordErrorHandler(error))
      let rangeText = ''
      // eslint-disable-next-line no-undef
      await Word.run(async function (context) {
        var _range = await context.document.getSelection()
        await _range.load('text')
        await context.sync()
        rangeText = _range.text.trim()
        if ((specificTreeEntry.genderSpecific.toLowerCase() || '') === rangeText.toLowerCase()) {
          await _range.insertText(personalizedShortformReplacement, 'Replace')
          await _range.select()
        }
        StatisticsService.incrementReplacementCounter(alternativeObject.pk).catch(e => {
          // instance.apiConnectionFailed = true
        })
        return Promise.resolve('ACK')
      })
        .catch(error => wordErrorHandler(error))

      StatisticsService.logReplacement(specificTreeEntry.genderSpecific, alternativeObject.pk).catch(e => {
        // instance.apiConnectionFailed = true
      })

      if (!rangeText) return Promise.resolve('no selection, maybe Word 2016')
      // We want the old paragraph to be scanned again, eg. when the user
      // presses Ctrl-Z and goes back to 'Die Studenten'.
      instance.paragraphTree = await removeFromArray(instance.paragraphTree, specificTreeEntry.hash)
      await this.getTransitionLock()

      this.highlightBuffer = { specific: this.highlightBuffer.specific, index: -1, numberOfOccurrence: this.highlightBuffer.numberOfOccurrence - 1 }
      this.postReplaceSuccess = this.$t('the word was successfully replaced')
      this.postReplaceInfo = this.$t('don\'t forget to adjust the grammar of the sentence')
      this.postReplaceNext = this.$t('You get to the next')
      if (this.highlightBuffer.numberOfOccurrence === 0) {
        const MS_WE_WANT_TO_WAIT_BEFORE_INFO_DISAPPREARS = 2345
        await wait(MS_WE_WANT_TO_WAIT_BEFORE_INFO_DISAPPREARS)
        await instance.hardUpdateSpecificTreeForView()
        this.isVisible[this.highlightBuffer.specific] = false
        this.highlightBuffer = { specific: '', index: -1, numberOfOccurrence: 0 }
        instance.specificTreeForView = await removeFromArray(instance.specificTreeForView, specificTreeEntry, 'genderSpecific')
        instance.specificTree = await removeFromArray(instance.specificTree, specificTreeEntry)
      }
      // instance.specificTree = await removeFromArray(instance.specificTree, specificTreeEntry)
      // We start back at the beginning
      await this.releaseTransitionLock()
      // basically so that 'Studierende' doesn't show after the replacement of 'Studenten'.
      this.blacklist.push(personalizedShortformReplacement)
      // We repull after a short break. This makes sure that duplication will be shown again
      await this.waitForSilence(1)
      await instance.hardUpdateSpecificTreeForView()
      // No need in the current implementation, because the next entry isn't opend automatically
      // const index = await this.specificTreeForView.indexOf(specificTreeEntry)
      // await this.highlightNext(index)
      return Promise.resolve('replaced')
    },
    removeDuplicatesByProp (myArr, prop) {
      if (!myArr) return
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos
      })
    },
    removeDuplicates (a) {
      return [...new Set(a.map(o => JSON.stringify(o)))].map(s => JSON.parse(s))
    },
    getUsername () {
      let username = Vue.default.cookie.get('username')
      if (!username) username = localStorage.getItem('genderAppUsername')
      // if (username === 'anonymous') return undefined
      return username
    }
  }
}

function removeFromArray (array, forDeletion, property) {
  if (property) {
    return array.filter(item => !(forDeletion[property] === item[property]))
  }
  return array.filter(item => !(forDeletion === item))
}

function cleanUpString (inputString, allowedCharacters = '[^a-zA-Z0-9öäüÖÄÜ\\s\\,\\.\\;\\n\\-\\?\\!\\*\\:\\/\\_]') {
  const regex = new RegExp('[^' + allowedCharacters + ']', 'g')
  return inputString.replace(regex, ' ')
}

async function wait (ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

function wordErrorHandler (error) {
  console.log('Error: ' + JSON.stringify(error))
  // eslint-disable-next-line no-undef
  if (error instanceof OfficeExtension.Error) {
    console.log('Debug info: ' + JSON.stringify(error.debugInfo))
  }
}

// eslint-disable-next-line no-extend-native
String.prototype.hashCode = function () {
  var hash = 0
  if ((this.length || 0) === 0) {
    return hash
  }
  for (var i = 0; i < (this.length || 0); i++) {
    var char = this.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash = hash & hash // Convert to 32bit integer
  }
  return hash
}
// eslint-disable-next-line no-extend-native
Number.prototype.mod = function (n) {
  return ((this % n) + n) % n
}
</script>
<style>
</style>
<style scoped>
.button {
  position: relative;
  background-color: #4CAF50;
  border: none;
  text-align: center;
  -webkit-transition-duration: 0.4s; /* Safari */
  transition-duration: 0.4s;
  text-decoration: none;
  overflow: hidden;
  cursor: pointer;
}

.button:after {
  content: "";
  background: #90EE90;
  display: block;
  position: absolute;
  padding-top: 300%;
  padding-left: 350%;
  margin-left: -20px!important;
  margin-top: -120%;
  opacity: 0;
  transition: all 0.8s
}

.button:active:after {
  padding: 0;
  margin: 0;
  opacity: 1;
  transition: 0s
}
  .please-scroll {
    white-space: nowrap;
    overflow: hidden;
    overflow-x: scroll;
  }

  .invisible-scrollbar::-webkit-scrollbar {
    /*Chrome*/
    display: none !important;
  }
  .invisible-scrollbar {
  /*FireFox*/
  scrollbar-width: none !important;
  /*IE10+*/
  -ms-overflow-style: -ms-autohiding-scrollbar;
  }

    .list-group-item {
        border: transparent;
    }

    .card-body {
        padding: 0.5rem;
        border: transparent;
    }

  .center-right {
    position: absolute;
    top: 50%;
    left: 20%;
    transform: translate(-50%, -50%);
  }

    .fade-out {
        animation: fadeOut ease 6s forwards;
    }

    @keyframes fadeOut {
        0% {
            opacity: 0.0;
        }
        5% {
            opacity: 0.0;
        }
        30% {
            opacity: 1;
        }
        100% {
            opacity: 1;
        }
    }
</style>
